export const NODE_ENV = process.env.PRODUCT_ENV;
const config = {
  development: {
    ROOT_PATH: 'https://api-ipp-dev.cpgroupcloud.com',
    SELLER_PATH:'https://purchase-admin-dev.cpgroupcloud.com',
    APPID: 'store_d944d4b3ff',
    KEY: '0fdd70de8b20ad622978c881e80cc234',
    // ROOT_PATH: 'http://172.16.28.1:8000'
  },
  production: {
    ROOT_PATH: 'https://api-ipp-i.cpgroupcloud.com',
    SELLER_PATH:'https://purchase-admin-i.cpgroupcloud.com',
    APPID: 'store_7c1e5a9b20',
    KEY: '9c3e7a1f5b8d2c604e9a1f7b3d6c8e2a',
  },
  stg: {
    ROOT_PATH: 'https://api-ipp-stg.cpgroupcloud.com',
    SELLER_PATH:'https://purchase-admin-stg.cpgroupcloud.com',
    APPID: 'store_d944d4b3ff',
    KEY: '0fdd70de8b20ad622978c881e80cc234',
  }
};

export const ROOT_PATH = config[NODE_ENV].ROOT_PATH;
export const SELLER_PATH = config[NODE_ENV].SELLER_PATH;
export const APPID = config[NODE_ENV].APPID;
export const KEY = config[NODE_ENV].KEY;
export const STATIC_RESOURCE = 'https://fe-ifarm.cpgroupcloud.com/static_resource';